export const deepCopy = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj; // Se não for um objeto, retorna o próprio valor
    }

    // Cria um novo objeto vazio que será preenchido com cópias profundas das propriedades
    const newObj = Array.isArray(obj) ? [] : {};

    // Para cada propriedade do objeto original, faz uma cópia profunda recursivamente
    for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            newObj[key] = deepCopy(obj[key]);
        }
    }

    return newObj;
};